var Vue = require('vue');
var $ = require('js/sw-jquery/sw-jquery');
var axios = require('axios');
var VueAxios = require('vue-axios');
var sw  = require('js/lib/sw');
var _ = require('underscore');
Vue.use(VueAxios, axios);

module.exports = function ($fragment) {
  $fragment.swFindWithSelf("[data-sw-reactivate-cc]").each(function () {
    new Vue({
      el: this,
      data: {
        ccTokens: sw.data.ccTokens,
        selectedCC: 0
      },
      methods: {
        reactivateCcToken: function() {
          var self = this;
          var ccToken = _.find(this.ccTokens, function(cc) {return cc.credit_card_token_id == self.selectedCC});
          var bodyData = new FormData();
          bodyData.set('userId', ccToken.user_id);
          bodyData.set('ccTokenId', ccToken.credit_card_token_id);
          var requestHeaders = {
            headers: {'Content-Type': 'multipart/form-data'}
          };
          this.$http.post('/cs-portal/user/reactive-cc-token',bodyData, requestHeaders)
            .then(function(){
              location.reload();
            }).catch(function(error){
              sw.notifications.error(error);
          })
        }
      }
    })
  });
};
